import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const ExtendedContent = (props) => {
  const { activeTab: defaultActiveTab, columns, children, wrapper } = props;
  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  const changeTab = (e) => {
    e.preventDefault();

    setActiveTab(e.target.innerText.trim());
  };

  useEffect(() => {
    const { current } = wrapper;
    // eslint-disable-next-line no-shadow
    const openTab = (activeTab) => {
      const tabs = Array.from(current.querySelectorAll(`[data-column]`));

      tabs.forEach((tab) => {
        if (tab.getAttribute('data-column') === activeTab) {
          tab.style.display = 'block'; // eslint-disable-line no-param-reassign
        } else {
          tab.style.display = 'none'; // eslint-disable-line no-param-reassign
        }
      });
    };

    if (current) {
      openTab(activeTab);
    }
  }, [wrapper, activeTab]);

  return (
    <>
      <div className="extended-content__tabs">
        {columns.map((name) => (
          <button
            type="button"
            onClick={changeTab}
            key={name}
            className={`extended-content__tab ${
              activeTab === name ? 'active' : ''
            }`}
          >
            {name}
          </button>
        ))}
      </div>

      {children}
    </>
  );
};

ExtendedContent.propTypes = {
  activeTab: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
  wrapper: PropTypes.shape({
    current: PropTypes.instanceOf(Element), // eslint-disable-line
  }).isRequired,
};

export default ExtendedContent;
